import { Icon } from '@synergy/icons';
import { Button, Flex } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../../contexts/AuthContext";
import { useGlobalFilterContext } from "../../../contexts/GlobalFilterProvider";
import Theme from "../../../styles/Theme/Theme";
import { MultipleSelectAtomic } from '../../Global/Atomics/MultipleSelectAtomic';
import { SelectAtomic } from "../../Global/Atomics/SelectAtomic";
import Spinner from "../../Global/Atomics/Spinner";
import { Text } from "../../Global/Atomics/Text";

const Image = styled.img`
    position: absolute;
    bottom: 15px;
    width: 128px;
    height: 60px;
    align-self: center;
    /* margin: 0 64px 0 64px; */
`;

export const Filters = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    const { tenant } = useAuthContext();

    const {
        dropdownEntity,
        entity,
        selectEntity,
        dropdownSubEntity,
        subEntity,
        setSubEntity,
        // copySubEntity,
        // setCopySubEntity,
        // setIsToApplyFilters,
        dataRegionsIsFetching,
        isFetchingMapIncidentsData,
        // dropdownClasses,
        // classes,
        // setClasses,
        dropdownSeverities,
        severitiesSelected,
        setSeveritiesSelected,
        dropdownImpactedFA,
        impactedFASelected,
        setImpactedFASelected,
        dropdownFAOwner,
        faOwnerSelected,
        setFAOwnerSelected,
        dropdownVenueType,
        venueTypeSelected,
        setVenueTypeSelected,
        dropdownsVenues,
        venuesSelected,
        setVenuesSelected,
        dropdownConfidential,
        confidentialSelected,
        setConfidentialSelected,
        selectedLayer
    } = useGlobalFilterContext();

    /**
     * Filters by layer selected.
     */
    const filtersByLayer = {
        'Log Items': ['venues'],
        'Incidents': ['venueType', 'venues', 'faOwner', 'impactedFA', 'severities', "confidential"],
    };

    /**
     * Checks if a filter is visible for the selected layer.
     *
     * @param {string} filterKey - The key of the filter to check.
     * @returns {boolean} - True if the filter is visible, false otherwise.
     */
    const isFilterVisible = (filterKey) => {
        if (!selectedLayer) return false;
        return filtersByLayer[selectedLayer]?.includes(filterKey);
    };


    return (
        <FiltersWrapper className={isOpen ? " is-open" : null}>
            <div className="filters-header">
                <Button
                    className="filters-button"
                    onClick={() => { setIsOpen(!isOpen) }}
                    type="text"
                    icon={
                        <Icon iconsize={'sm'} icon={isOpen === true ? 'Collapse' : 'CollapseOpen'} color={'blue-4'} />
                    }
                />
                {isOpen ?
                    <Text textcolor='coolgray-12' marginleft='s03' textsize='text_sm' textweight='regular' $alignItems='center'>{t('filters')}</Text> : null
                }
            </div>
            {isOpen ?
                <>
                    {tenant &&
                        !dataRegionsIsFetching && dropdownEntity ?
                        <div className="filter-content">
                            {dropdownEntity?.length > 1 ?
                                <div className="filter-content-item">
                                    <SelectAtomic optionsData={dropdownEntity} handleOptionsChange={(value, record) => { selectEntity(record) }}
                                        defaultValue={entity?.value} fullWidth={true} />
                                </div>
                                : null}

                            {dropdownSubEntity ?
                                <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                    <SelectAtomic optionsData={dropdownSubEntity} handleOptionsChange={(value, record) => { if (record) { setSubEntity(record) } }}
                                        defaultValue={subEntity?.value} fullWidth={true} />
                                </div>
                                : null}


                            {!isFetchingMapIncidentsData ?
                                <>
                                    {/* {dropdownClasses && dropdownClasses.length > 0 ?
                                            <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                                <MultipleSelectAtomic
                                                    optionsData={dropdownClasses}
                                                    handleOptionsChange={(placeholder, values) => {
                                                        if (values) {
                                                            setClasses(values);
                                                        }
                                                    }}
                                                    defaultValue={classes}
                                                    fullWidth={true}
                                                    placeholder={"Select classes"}
                                                    allAvailable={true}
                                                    noTags={true}
                                                />
                                            </div>
                                            : null} */}

                                    {isFilterVisible("venueType") && dropdownVenueType?.length > 0 ?
                                        <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                            <MultipleSelectAtomic
                                                optionsData={dropdownVenueType}
                                                handleOptionsChange={(placeholder, values) => {
                                                    if (values) {
                                                        setVenueTypeSelected(values);
                                                    }
                                                }}
                                                defaultValue={venueTypeSelected}
                                                fullWidth={true}
                                                placeholder={"Select Venue Type"}
                                                allAvailable={true}
                                                noTags={true}
                                            />
                                        </div>
                                        : null}

                                    {isFilterVisible("venues") && dropdownsVenues?.length > 0 ?
                                        <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                            <MultipleSelectAtomic
                                                optionsData={dropdownsVenues}
                                                handleOptionsChange={(placeholder, values) => {
                                                    if (values) {
                                                        setVenuesSelected(values);
                                                    }
                                                }}
                                                defaultValue={venuesSelected}
                                                fullWidth={true}
                                                placeholder={"Select Venue"}
                                                allAvailable={true}
                                                noTags={true}
                                            />
                                        </div>
                                        : null}

                                    {/* Venues or Locations */}

                                    {isFilterVisible("faOwner") && dropdownFAOwner?.length > 0 ?
                                        <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                            <MultipleSelectAtomic
                                                optionsData={dropdownFAOwner}
                                                handleOptionsChange={(placeholder, values) => {
                                                    if (values) {
                                                        setFAOwnerSelected(values);
                                                    }
                                                }}
                                                defaultValue={faOwnerSelected}
                                                fullWidth={true}
                                                placeholder={"Select FA Owner"}
                                                allAvailable={true}
                                                noTags={true}
                                            />
                                        </div>
                                        : null}

                                    {isFilterVisible("impactedFA") && dropdownImpactedFA?.length > 0 ?
                                        <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                            <MultipleSelectAtomic
                                                optionsData={dropdownImpactedFA}
                                                handleOptionsChange={(placeholder, values) => {
                                                    if (values) {
                                                        setImpactedFASelected(values);
                                                    }
                                                }}
                                                defaultValue={impactedFASelected}
                                                fullWidth={true}
                                                placeholder={"Select Impacted FA"}
                                                allAvailable={true}
                                                noTags={true}
                                            />
                                        </div>
                                        : null}

                                    {isFilterVisible("severities") && dropdownSeverities?.length > 0 ?
                                        <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                            <MultipleSelectAtomic
                                                optionsData={dropdownSeverities}
                                                handleOptionsChange={(placeholder, values) => {
                                                    if (values) {
                                                        setSeveritiesSelected(values);
                                                    }
                                                }}
                                                defaultValue={severitiesSelected}
                                                fullWidth={true}
                                                placeholder={"Select Priorities"}
                                                allAvailable={true}
                                                noTags={true}
                                            />
                                        </div>
                                        : null}

                                    {isFilterVisible("confidential") && dropdownConfidential?.length > 0 ?
                                        <div className="filter-content-item" style={{ marginBottom: '0.5rem' }}>
                                            <MultipleSelectAtomic
                                                optionsData={dropdownConfidential}
                                                handleOptionsChange={(placeholder, values) => {
                                                    if (values) {
                                                        setConfidentialSelected(values);
                                                    }
                                                }}
                                                defaultValue={confidentialSelected}
                                                fullWidth={true}
                                                placeholder={"Select Confidentiality"}
                                                allAvailable={true}
                                                noTags={true}
                                            />
                                        </div>
                                        : null}

                                </>
                                : <Flex justify="center" style={{ margin: '10px 0' }}><Spinner stroke="green" size='30px' /></Flex>}


                            {/* <Flex gap='middle' vertical="true">
                                    <Button shape="round" className="ant-btn-blue -small" onClick={() => onApplyFilters()}>{t('apply')}</Button>
                                </Flex> */}
                        </div>
                        : <Flex justify="center"><Spinner stroke="green" size='30px' /></Flex>


                    }
                    {!tenant &&
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{t('User withou a tenant')}</div>}
                </>
                : null
            }
        </FiltersWrapper >
    )
}

const FiltersWrapper = styled.div.attrs({
    className: 'with-bg-color',
})`
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: ${Theme.color['neutral-2']};
    padding: ${Theme.spacing['s07']} ${Theme.spacing['s05']};
    width: auto;
    height: -webkit-fill-available; /* Doesnt work in all browsers */
    /* height: 100%; */

    &.is-open {
        width: 234px;
        height: 100%;
    }

    .filters-header{
        display: flex;
        margin-bottom: ${Theme.spacing['s07']};

        .filters-title{
            display: flex;
            align-items: center;
        }
        .filters-button{
            cursor: pointer;
        }
    };

    .filter-content{
        overflow-y: auto;
        height: 100%;

        &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${Theme.color['coolgray-2']};
            border-radius: 10px;
        }
        
        .filter-content-item{
            margin-bottom: ${Theme.spacing['s07']};

            .antdSelect{
                width: 100%;

                .ant-select-arrow{
                    color: ${Theme.color['blue-4']};
                    font-size: unset;
                }

                .ant-select-selector{
                    min-height: 48px;
                    border: none;

                    .ant-select-selection-placeholder{//if mode is none need this property to center
                        align-self: center;
                    }

                    .ant-select-selection-item{//if mode is none need this property to center
                        align-self: center;
                    }
                }
            }

            .ant-picker{
                width: 100%;
                height: 48px;
                border: none;

                .ant-picker-suffix{
                    color: ${Theme.color['blue-4']};
                }
            }

            .noContent { 
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .submit-content{
            display: flex;
            flex-direction: column;
            padding: 8px 0px 0px 0px;//Top padding 32px - s07 = 8px;
            
            .buttonFilter{
                border-radius: 20px;
                cursor: pointer;
                font-size: ${Theme.typography.fontSize['text_sm_desktop']};
            }
            
            .saveFilter{
                background-color: transparent;
                height: 40px;
                border-color: ${Theme.color['coolgray-2']};
                border-style: solid;
                margin-bottom: ${Theme.spacing['s05']};

                &:hover{
                    border-color: ${Theme.color['black-1']};
                    /* background-color: ${Theme.color['coolgray-4']}; */
                }

                &:focus{
                    color: ${Theme.color['black-1']};
                    background-color: ${Theme.color['white']};
                    border-color: ${Theme.color['blue-2']};
                }

                &:disabled{
                    color: ${Theme.color['black-1']};
                    background-color: #F8F8F8;
                    cursor: not-allowed;
                    border-color: ${Theme.color['coolgray-2']};
                }
            }

            .whiteButton{
                &:disabled{
                    color: ${Theme.color['coolgray-11']};
                    background-color: ${Theme.color['coolgray-2']};
                    cursor: not-allowed;
                }
            }
        }
    }
`;